import { ENV } from '@qunhe/egs-lib';

export const GLOBAL_CONFIG = {
    isDebugEnable: ENV.isDebugEnable,
    meshBVHEnabled: false,
};
